import React, { Component, Suspense } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import ThemeListTemplate from './ContentsTab/ThemeListTemplate';
import AddTextTemplate from './TextTab/AddTextTemplate';
import UploadTemplate from './UploadTab/UploadTemplate';
import SettingsTemplate from './SettingsTab/SettingsTemplate';
import { connect } from 'react-redux';
import * as sideBarActions from '../../redux/sideBarActions';
import * as fabricCanvasActions from '../../redux/fabricCanvasActions';
import * as multiWallHandler from '../../redux/actions/multiWallHandler';
import * as gaHelpers from '../../utilities/GAHelpers/GAHelpers';
import { bindActionCreators } from 'redux';
import { Icons } from '../../utilities';
import * as Constants from '../../utilities/constants/Constants';
import { string } from '../../localization';
import Templates from './TemplatesTab/Templates';
import Material from './MaterialTab/Material';
import * as sideBarTimeUtiles from '../../utilities/TimerUtils/SidebarTimerUtils';
import './SideBarContainer.scss';
import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary';
import { checkIfCanvasApp } from '../../redux/homeActions';
import AI from './AI/AI';

const MyRoomTab = React.lazy(() => import('./MyRoomTab/MyRoomTab'));

class SideBar extends Component {
  componentDidMount() {
    const { dispatchers, project } = this.props;
    if (localStorage.getItem('showHelpWindow') || project.id !== null) {
      dispatchers.timer.startTimer();
    }
  }

  componentWillUnmount() {
    const { dispatchers } = this.props;
    dispatchers.timer.stopTimer();
  }

  onScrollUp = dict => {
    const topPos = document.getElementById(`help-${dict[0].tab_id}`).offsetTop;
    document.getElementById('scrollUp').scrollTop = topPos - 20;
  };

  onScrollDown = () => {
    const topPos = document.getElementById('help-upload').offsetTop;
    document.getElementById('scrollUp').scrollTop = topPos + 20;
  };

  classForSideBarContainer = () => {
    const { enterpriseAccount, storeData, progressData } = this.props;

    let className = 'text-center';

    if (enterpriseAccount) {
      if (storeData.commonSetting.useLargerLogo) {
        className = 'text-center space-for-larger-icon';
      } else {
        className = 'text-center';
      }
    }
    if (progressData !== 100) {
      className += ' loading-indicator-sidebar';
    }
    return className;
  };

  getElement = id => {
    if (id) {
      if (document.getElementById(id)) {
        return document.getElementById(id);
      }
    }
    return null;
  };

  isOverflowing = element => {
    if (element) {
      return element.scrollHeight > element.offsetHeight;
    }
    return false;
  };

  handleScrollButtonVisibility = id => {
    const element = this.getElement(id);
    if (this.isOverflowing(element)) {
      return true;
    }
    return false;
  };

  render() {
    const {
      activeTab,
      data,
      storeData,
      commonSetting,
      enterpriseAccount,
      showSideBar,
      progressData,
      dispatchers,
      enableOpenAi
    } = this.props;

    const sideBarOptions = [
      {
        name: string.MYROOM_UPPERCASE_KEY,
        alt_text: 'room-icon',
        tab_id: Constants.MY_ROOM_TAB_KEY,
        img_url: Icons.roomIcon,
        id: Constants.MY_ROOM_TAB_KEY
      },
      {
        name: string.TEMPLATES_UPPER_CASE_KEY,
        alt_text: 'templates-icon',
        tab_id: Constants.TEMPLATES_TAB_KEY,
        img_url: Icons.templates,
        id: Constants.TEMPLATES_KEY
      },
      {
        name: string.BACKGROUND_UPPER_CASE_KEY,
        alt_text: 'background-icon',
        tab_id: Constants.BACKGROUND_TAB_KEY,
        img_url: Icons.background,
        id: Constants.BACKGROUNDS_KEY
      },
      {
        name: string.PHOTOS_KEY,
        alt_text: 'photos-icon',
        tab_id: Constants.PHOTO_TAB_KEY,
        img_url: Icons.photos,
        id: Constants.PHOTOS_KEY
      },
      {
        name: string.OBJECTS_UPPER_CASE_KEY,
        alt_text: 'objects-icon',
        tab_id: Constants.ELEMENT_TAB_KEY,
        img_url: Icons.objects,
        id: Constants.OBJECTS_KEY
      },
      {
        name: string.TEXT_UPPERCASE_KEY,
        alt_text: 'text-icon',
        tab_id: Constants.TEXT_ELEMENT_TYPE,
        img_url: Icons.text,
        id: Constants.TEXT_KEY
      },
      {
        name: string.MATERIAL_TITLE_KEY,
        alt_text: 'material-icon',
        tab_id: Constants.MATERIAL_TAB_KEY,
        img_url: Icons.material,
        id: Constants.MATERIALS_KEY
      },
      {
        name: string.UPLOAD_UPPERCASE_KEY,
        alt_text: 'upload-icon',
        tab_id: Constants.UPLOAD_TAB_KEY,
        img_url: Icons.myContent,
        id: Constants.UPLOAD_KEY
      },
      {
        name: string.AI,
        alt_text: 'ai-icon',
        tab_id: Constants.OPEN_AI,
        img_url: Icons.light_bulb,
        id: Constants.OPEN_AI
      },
      {
        name: string.SETTINGS_UPPERCASE_KEY,
        alt_text: 'settings-icon',
        tab_id: Constants.SETTINGS_TAB_KEY,
        img_url: Icons.settings,
        id: Constants.SETTINGS_KEY
      }
    ];

    const dict = [];
    let isSettingsEnabled = false;
    if (progressData === 100) {
      dispatchers.sideBarActions.createThemeThumbnails();

      for (let i = 0; i < sideBarOptions.length; i++) {
        if (sideBarOptions[i].tab_id === Constants.MY_ROOM_TAB_KEY) {
          if (dispatchers.sideBarActions.canShowMyRoomTab()) {
            dict.push(sideBarOptions[i]);
          }
        } else if (
          sideBarOptions[i].tab_id === Constants.BACKGROUND_TAB_KEY ||
          sideBarOptions[i].tab_id === Constants.ELEMENT_TAB_KEY ||
          sideBarOptions[i].tab_id === Constants.PHOTO_TAB_KEY
        ) {
          if (data[sideBarOptions[i].tab_id].length > 0) {
            dict.push(sideBarOptions[i]);
          }
        } else if (sideBarOptions[i].tab_id === Constants.MATERIAL_TAB_KEY) {
          if (
            storeData.materials.length > 1 ||
            dispatchers.checkIfCanvasApp()
          ) {
            dict.push(sideBarOptions[i]);
          }
        } else if (
          sideBarOptions[i].tab_id === Constants.TEXT_ELEMENT_TYPE ||
          sideBarOptions[i].tab_id === Constants.UPLOAD_TAB_KEY
        ) {
          if (!dispatchers.sideBarActions.checkOmenLaptopOfTurkeyAccount()) {
            dict.push(sideBarOptions[i]);
          }
        } else if (sideBarOptions[i].tab_id === Constants.TEMPLATES_TAB_KEY) {
          if (dispatchers.sideBarActions.canShowTemplatesTab()) {
            dict.push(sideBarOptions[i]);
          }
        } else if (sideBarOptions[i].tab_id === Constants.SETTINGS_TAB_KEY) {
          if (storeData.supportsDesignerSettings) {
            dict.push(sideBarOptions[i]);
            isSettingsEnabled = true;
          }
        } else if (sideBarOptions[i].tab_id === Constants.OPEN_AI) {
          if (enableOpenAi) {
            dict.push(sideBarOptions[i]);
          }
        } else {
          dict.push(sideBarOptions[i]);
        }
      }
      if (activeTab === null && dict.length) {
        dispatchers.sideBarActions.tabChangeEvent(dict);
      }
    }
    const contentAreaColor =
      commonSetting && !commonSetting.useDefaultColors
        ? `#${commonSetting.contentAreaColor}`
        : null;
    const sideBarClass = this.classForSideBarContainer();
    return progressData !== 100 ? (
      <div className={sideBarClass} id='sidebar' />
    ) : (
      <div className={sideBarClass} id='sidebar'>
        <div id='container'>
          {this.handleScrollButtonVisibility('scrollUp') ? (
            <button
              type='button'
              style={{ outline: 'none', border: 'none' }}
              className={[
                'scrollUpTxt',
                !showSideBar ? 'scroll-down-arrow' : null
              ].join(' ')}
              onClick={() => this.onScrollUp(dict)}
            >
              <img src={Icons.down_arrow} alt='down-arrow' />
            </button>
          ) : null}
          <div>
            <Nav
              id='scrollUp'
              pills
              vertical
              className={[
                'text-white',
                this.handleScrollButtonVisibility('scrollUp') ? 'mt-4' : null
              ].join(' ')}
            >
              {dict.map(option => (
                <NavItem
                  className={[
                    isSettingsEnabled
                      ? 'listItems1 settings-tab'
                      : 'listItems2 settings-tab1',
                    !showSideBar ? 'setting-tab-visblity' : null
                  ].join(' ')}
                  key={option.alt_text}
                  id={`help-${option.tab_id}`}
                >
                  <NavLink
                    className={classnames({
                      active: activeTab === option.tab_id
                    })}
                    onClick={() => {
                      dispatchers.sideBarActions.handleTabChange(option.tab_id);
                    }}
                  >
                    <div className='d-flex justify-content-center align-items-center'>
                      <div
                        className='icon-wrapper'
                        style={{
                          width: option.id == Constants.OPEN_AI ? 'auto' : '',
                          height: option.id == Constants.OPEN_AI ? 'auto' : ''
                        }}
                      >
                        <img alt={option.alt_text} src={option.img_url} />
                      </div>
                    </div>
                    {option.name}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </div>
          {this.handleScrollButtonVisibility('scrollUp') ? (
            <button
              type='button'
              style={{ outline: 'none', border: 'none' }}
              className={[
                isSettingsEnabled ? 'scrollDownTxt' : 'scrollDownTxt1',
                !showSideBar ? 'scroll-down-arrow' : null
              ].join(' ')}
              onClick={this.onScrollDown}
            >
              <img src={Icons.up_arrow} alt='down-arrow' />
            </button>
          ) : null}
        </div>

        <TabContent
          activeTab={activeTab}
          style={{
            backgroundColor: enterpriseAccount ? contentAreaColor : null
          }}
        >
          <TabPane tabId={Constants.MY_ROOM_TAB_KEY}>
            <ErrorBoundary>
              <Suspense
                fallback={
                  <div className=' loading-indicator-sidebar' id='loader' />
                }
              >
                <MyRoomTab />
              </Suspense>
            </ErrorBoundary>
          </TabPane>

          <TabPane tabId={Constants.TEMPLATES_TAB_KEY}>
            <ErrorBoundary>
              <Templates />
            </ErrorBoundary>
          </TabPane>

          <TabPane tabId={Constants.BACKGROUND_TAB_KEY}>
            <ErrorBoundary>
              <ThemeListTemplate tabKey={Constants.BACKGROUND_TAB_KEY} />
            </ErrorBoundary>
          </TabPane>

          <TabPane tabId={Constants.PHOTO_TAB_KEY}>
            <ErrorBoundary>
              <ThemeListTemplate tabKey={Constants.PHOTO_TAB_KEY} />
            </ErrorBoundary>
          </TabPane>

          <TabPane tabId={Constants.ELEMENT_TAB_KEY}>
            <ErrorBoundary>
              <ThemeListTemplate tabKey={Constants.ELEMENT_TAB_KEY} />
            </ErrorBoundary>
          </TabPane>

          <TabPane tabId={Constants.TEXT_ELEMENT_TYPE}>
            <ErrorBoundary>
              <AddTextTemplate />
            </ErrorBoundary>
          </TabPane>
          <TabPane tabId={Constants.MATERIAL_TAB_KEY}>
            <ErrorBoundary>
              <Material />
            </ErrorBoundary>
          </TabPane>
          <TabPane tabId={Constants.UPLOAD_TAB_KEY}>
            <ErrorBoundary>
              <UploadTemplate />
            </ErrorBoundary>
          </TabPane>
          <TabPane tabId={Constants.SETTINGS_TAB_KEY}>
            <ErrorBoundary>
              <SettingsTemplate />
            </ErrorBoundary>
          </TabPane>

          <TabPane tabId={Constants.OPEN_AI}>
            <ErrorBoundary>
              <AI />
            </ErrorBoundary>
          </TabPane>
        </TabContent>
      </div>
    );
  }
}

// const SideBar = props => {
//   const { activeTab, data, storeData } = props;

function mapStateToProps(state) {
  return {
    progressData: state.modal.progressData,
    activeTab: state.sideBar.activeSideBarTab,
    data: state.modal,
    storeData: state.modal.storeData,
    language: state.home.language,
    enterpriseAccount: state.modal.envData.enterprise_account,
    commonSetting: state.modal.storeData.commonSetting,
    moreImagesLoadingIndicator: state.sideBar.showLoading,
    envData: state.modal.envData,
    loadingState: state.fabricCanvas.loadingState,
    timeStampForDesigner: state.modal.envData.edit_duration,
    enableOpenAi: state.modal.storeData.enableOpenAi,
    tabTime: state.sideBar.tabTime,
    tabName: state.sideBar.tabName,
    project: state.finalCheck.project,
    showSideBar: state.sideBar.showSideBar
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      multiWallHandler: bindActionCreators(multiWallHandler, dispatch),
      timer: bindActionCreators(sideBarTimeUtiles, dispatch),
      gaHelpers: bindActionCreators(gaHelpers, dispatch),
      checkIfCanvasApp: bindActionCreators(checkIfCanvasApp, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
